import { render, staticRenderFns } from "./IPLCampaignBase.vue?vue&type=template&id=0cd4b711&"
import script from "./IPLCampaignBase.vue?vue&type=script&lang=js&"
export * from "./IPLCampaignBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports